import React, { useRef, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Login, otp_verification } from '../../../Global/Index';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
const apiurl = process.env.REACT_APP_API_URL;

const CreateVerifyOtp = ({ Mobile_Number, customerLocationDetails }) => {
    const [otpError, setOtpError] = useState('');
    const [otpSuccess, setOtpSuccess] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [timeLeft, setTimeLeft] = useState(60);
    const [showResendLink, setShowResendLink] = useState(false);
    const [hasVerified, setHasVerified] = useState(false);
    const navigate = useNavigate();

    // Auto-focus first input on mount
    useEffect(() => {
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, []);

    const handleInput = (e, index) => {
        const value = e.target.value;
        if (/^\d$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            setOtpError('');
            if (index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            e.preventDefault();
            const newOtp = [...otp];
            
            if (otp[index]) {
                newOtp[index] = '';
                setOtp(newOtp);
            } else if (index > 0) {
                newOtp[index - 1] = '';
                setOtp(newOtp);
                inputRefs.current[index - 1].focus();
            }
            setOtpError('');
            setHasVerified(false);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').slice(0, 6);
        if (/^\d+$/.test(pastedData)) {
            const newOtp = pastedData.split('').concat(Array(6).fill('')).slice(0, 6);
            setOtp(newOtp);
            const lastFilledIndex = Math.min(pastedData.length - 1, 5);
            inputRefs.current[lastFilledIndex]?.focus();
        }
    };

    const verifyotp = useCallback(async ({ otpstring }) => {
        if (isVerifying || hasVerified) return;
        
        setIsVerifying(true);
        setHasVerified(true);
        setOtpError('');
        
        try {
            const otpinput = {
                Mobile_Num: Mobile_Number,
                OTP: otpstring
            };

            const response = await otp_verification(otpinput);
            
            if (response.message === "OTP is valid" && response.status === 201) {
                setOtpSuccess(true);
                setOtpError('');

                try {
                    const loginResponse = await Login(Mobile_Number, customerLocationDetails);
                    if (loginResponse.status === 201) {
                        const token = Cookies.get('token');
                        if (token !== null) {
                            localStorage.setItem('activeLinkId', "1");
                            localStorage.setItem('dropedownid', "[]");
                            navigate('/dashboard');
                        }
                    } else {
                        setOtpError('Login failed. Please try again later!');
                        setOtpSuccess(false);
                    }
                } catch (error) {
                    console.log(error);
                    toast.error('Something went wrong. Please try again later!');
                    setOtpSuccess(false);
                }
            } else {
                setOtpError(response.message || 'Invalid OTP. Please try again.');
                setOtpSuccess(false);
            }
        } catch (error) {
            setOtpError('Verification failed. Please try again.');
            setOtpSuccess(false);
            console.error('Error:', error);
        } finally {
            setIsVerifying(false);
        }
    }, [Mobile_Number, navigate, customerLocationDetails, isVerifying, hasVerified]);

    useEffect(() => {
        if (otp.every(digit => digit !== '') && !hasVerified) {
            verifyotp({ otpstring: otp.join('') });
        }
    }, [otp, verifyotp, hasVerified]);

    useEffect(() => {
        if (timeLeft === 0) {
            setShowResendLink(true);
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft((prevTimeLeft) => {
                if (prevTimeLeft > 0) {
                    if (prevTimeLeft - 1 === 10) {
                        setShowResendLink(true);
                    }
                    return prevTimeLeft - 1;
                } else {
                    return 0;
                }
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft]);

    const resendOtp = async () => {
        setShowResendLink(false);
        setTimeLeft(60);
        setOtp(['', '', '', '', '', '']);
        setOtpError('');
        setOtpSuccess(false);
        setHasVerified(false);
        
        try {
            await axios.post(`${apiurl}/send-sms`, { Mobile_Number });
            toast.success('OTP sent successfully to your registered mobile number');
            if (inputRefs.current[0]) {
                inputRefs.current[0].focus();
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to resend OTP. Please try again.');
        }
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className="otp-verification-container" style={{
            maxWidth: '420px',
            margin: '0 auto',
            padding: '1.5rem 1rem',
            marginTop:'-3vh'
        }}>
            {/* Header Section */}
            {/* <div style={{
                textAlign: 'center',
                marginBottom: '1.5rem'
            }}>
                <h2 style={{
                    fontSize: '1.25rem',
                    fontWeight: '600',
                    color: '#1f2937',
                    marginBottom: '0.5rem'
                }}>
                    Verify Your Number
                </h2>
                <p style={{
                    fontSize: '0.8rem',
                    color: '#6b7280',
                    lineHeight: '1.4'
                }}>
                    Enter the 6-digit code sent to<br />
                    <span style={{ fontWeight: '600', color: '#374151' }}>
                        +91 {Mobile_Number}
                    </span>
                </p>
            </div> */}

            {/* OTP Input Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '0.5rem',
                marginBottom: '1.25rem'
            }}>
                {[0, 1, 2, 3, 4, 5].map((_, index) => (
                    <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        maxLength="1"
                        ref={el => inputRefs.current[index] = el}
                        value={otp[index]}
                        onInput={(e) => handleInput(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={index === 0 ? handlePaste : undefined}
                        disabled={isVerifying || otpSuccess}
                        style={{
                            width: '2.6rem',
                            height: '2.9rem',
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            textAlign: 'center',
                            border: `2px solid ${
                                otpError && otp[index] ? '#ef4444' : 
                                otpSuccess && otp[index] ? '#10b981' : 
                                otp[index] ? 'rgb(155, 19, 74)' : '#d1d5db'
                            }`,
                            borderRadius: '0.375rem',
                            outline: 'none',
                            transition: 'all 0.2s',
                            backgroundColor: otpSuccess ? '#f0fdf4' : '#ffffff',
                            color: '#1f2937',
                            caretColor: 'rgb(155, 19, 74)'
                        }}
                        onFocus={(e) => {
                            if (!isVerifying && !otpSuccess) {
                                e.target.style.borderColor = otpError ? '#ef4444' : 'rgb(155, 19, 74)';
                                e.target.style.boxShadow = `0 0 0 3px ${otpError ? 'rgba(239, 68, 68, 0.1)' : 'rgba(59, 130, 246, 0.1)'}`;
                            }
                        }}
                        onBlur={(e) => {
                            e.target.style.borderColor = otp[index] ? (otpError ? '#ef4444' : otpSuccess ? '#10b981' : '#3b82f6') : '#d1d5db';
                            e.target.style.boxShadow = 'none';
                        }}
                    />
                ))}
            </div>

            {/* Status Messages */}
            {otpError && (
                <div style={{
                    padding: '0.625rem 0.875rem',
                    backgroundColor: '#fef2f2',
                    border: '1px solid #fecaca',
                    borderRadius: '0.375rem',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }}>
                    <svg style={{ width: '1rem', height: '1rem', color: '#ef4444', flexShrink: 0 }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                    <span style={{ fontSize: '0.8rem', color: '#991b1b', fontWeight: '500' }}>
                        {otpError}
                    </span>
                </div>
            )}

            {otpSuccess && (
                <div style={{
                    padding: '0.625rem 0.875rem',
                    backgroundColor: '#f0fdf4',
                    border: '1px solid #bbf7d0',
                    borderRadius: '0.375rem',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }}>
                    <svg style={{ width: '1rem', height: '1rem', color: '#10b981', flexShrink: 0 }} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span style={{ fontSize: '0.8rem', color: '#065f46', fontWeight: '500' }}>
                        OTP verified successfully!
                    </span>
                </div>
            )}

            {isVerifying && (
                <div style={{
                    padding: '0.625rem 0.875rem',
                    backgroundColor: '#eff6ff',
                    border: '1px solid #bfdbfe',
                    borderRadius: '0.375rem',
                    marginBottom: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        width: '0.875rem',
                        height: '0.875rem',
                        border: '2px solid #3b82f6',
                        borderTopColor: 'transparent',
                        borderRadius: '50%',
                        animation: 'spin 0.8s linear infinite'
                    }} />
                    <span style={{ fontSize: '0.8rem', color: '#1e40af', fontWeight: '500' }}>
                        Verifying...
                    </span>
                </div>
            )}

            {/* Timer and Resend Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '0.875rem',
                borderTop: '1px solid #e5e7eb'
            }}>
                <div style={{
                    fontSize: '0.8rem',
                    color: timeLeft <= 10 ? '#dc2626' : '#6b7280',
                    fontWeight: timeLeft <= 10 ? '600' : '400'
                }}>
                    {timeLeft > 0 ? (
                        <>
                            <span>Code expires in </span>
                            <span style={{ 
                                fontFamily: 'monospace',
                                fontSize: '0.85rem',
                                fontWeight: '600'
                            }}>
                                {formatTime(timeLeft)}
                            </span>
                        </>
                    ) : (
                        <span style={{ color: '#dc2626', fontWeight: '600' }}>
                            Code expired
                        </span>
                    )}
                </div>

                {showResendLink && (
                    <button
                        onClick={resendOtp}
                        disabled={isVerifying}
                        style={{
                            fontSize: '0.8rem',
                            fontWeight: '600',
                            color: '#3b82f6',
                            background: 'none',
                            border: 'none',
                            cursor: isVerifying ? 'not-allowed' : 'pointer',
                            padding: '0.25rem 0.5rem',
                            borderRadius: '0.25rem',
                            transition: 'all 0.2s',
                            opacity: isVerifying ? 0.5 : 1
                        }}
                        onMouseEnter={(e) => {
                            if (!isVerifying) {
                                e.target.style.backgroundColor = '#eff6ff';
                                e.target.style.textDecoration = 'underline';
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.textDecoration = 'none';
                        }}
                    >
                        Resend Code
                    </button>
                )}
            </div>

            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

CreateVerifyOtp.propTypes = {
    Mobile_Number: PropTypes.string.isRequired,
    customerLocationDetails: PropTypes.object
};

export default CreateVerifyOtp;